import {Moment} from 'moment-timezone';
import {User} from '@app/layout/admin/services/api/user-interfaces';
import {BacerConfig} from '@app/layout/sitemanager/bacers/bacer-config/bacer.types';
import {LicenseTier} from '@app/shared/util/general/license';
import {TicketType} from '@app/shared/services/api/tickets/tickets.interface';

export type Maybe<T> = T | null;

export type DateTime = any;

export type JSON = any;

export type Long = number;

export enum CollectorType {
  Virtual = 'Virtual',
  Physical = 'Physical'
}

export enum BuildingType {
  COMMERCIAL = 'Commercial',
  RETAIL = 'Retail',
  HOTEL = 'Hotel',
  MUSEUM = 'Museum',
  UNIVERSITY = 'University',
  MANUFACTURING = 'Manufacturing',
  OTHER = 'Other'
}

export enum MeterType {
  NMI = 'NMI',
  PHYSICAL = 'Physical',
  VIRTUAL = 'Virtual'
}

export enum MeterUtilityType {
  ELECTRICITY = 'Electricity',
  GAS = 'Gas',
  WATER = 'Water'
}

export enum UtilityTypeMetadataTypeId {
  ELECTRICITY = 21,
  GAS = 69,
  WATER = 70
}

export enum StreamData {
  ACTIVE_IMPORT = 'active_import', ACTIVE_EXPORT = 'active_export',
  REACTIVE_IMPORT = 'reactive_import', REACTIVE_EXPORT = 'reactive_export'
}

export enum Currency {
  AUSTRALIAN_DOLLAR = 'Australian Dollar',
  BRAZILIAN_REAL = 'Brazilian Real',
  CANADIAN_DOLLAR = 'Canadian Dollar',
  CHINESE_YUAN = 'Chinese Yuan',
  EURO = 'Euro',
  INDONESIAN_RUPIAH = 'Indonesian Rupiah',
  NEW_ZEALAND_DOLLAR = 'New Zealand Dollar',
  POUND_STERLING = 'Pound Sterling',
  SINGAPORE_DOLLAR = 'Singapore Dollar',
  SWEDISH_KRONA = 'Swedish Krona',
  SWISS_FRANC = 'Swiss Franc',
  UNITED_STATES_DOLLAR = 'United States Dollar'
}

export enum VirtualMeterCalculationType {
  ALL_SIBLINGS_SUBTRACTED = 'ALL_SIBLINGS_SUBTRACTED',
  SELECTED_SIBLINGS_SUBTRACTED = 'SELECTED_SIBLINGS_SUBTRACTED',
  SELECTED_CHILDREN_SUMMED =  'SELECTED_CHILDREN_SUMMED'
}

export type Scalars = {
  CollectorType: CollectorType;
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Double: number;
  JSON: any;
  Long: number;
  DateTime: any;
  LocalDate: any;
  Period: any;
  MeterTypeEnum: MeterType;
  StreamDataTypeEnum: StreamData;
  MeterUtilityTypeEnum: MeterUtilityType;
  BuildingTypeEnum: BuildingType;
  VirtualMeterCalculationTypeEnum: VirtualMeterCalculationType;
  LicenseTierEnum: LicenseTier;
  TicketType: TicketType;
};


/* Root of all queries. */
export interface QueryRoot {
  collectors?: Collector[] | null /* Search Collectors. */;
  contractors?: Contractor[] | null /* Search Contractors. */;
  devices?: Device[] | null /* Search Devices. */;
  equipment?: Equipment[] | null /* Search Equipment. */;
  favourites?: Favourite[] | null /* Search Favourites. */;
  history?: History[] | null /* Search Favourite History. */;
  history_count?: HistoryCount | null /* Get History Count for Favourites. */;
  metadata?: Metadata[] | null /* Search Metadata. */;
  metadata_types?: MetadataType[] | null /* Search Metadata Types. */;
  metadata_units?: MetadataUnit[] | null /* Search Metadata Units. */;
  meter_providers?: MeterProvider[] | null /* Search Meter Providers. */;
  sites?: Site[] | null /* Search Sites. */;
}

export interface CollectorNote {
  collector_note_id: string;
  note_text: string;
  user_id: string;
  created_at: Moment;
  last_modified_at: Moment;
}

/* A Collector. */
export interface Collector {
  site_id?: number;
  bacnet_broadcast?: string | null /* BACNet broadcast address. */;
  bacnet_scan_range?: string | null /* BACNet scan range. */;
  broadcast?:
    | string
    | null /* Primary physical network interface Broadcast address. */;
  broadcast_2?:
    | string
    | null /* Secondary physical network interface Broadcast address. */;
  collection_interval?:
    | string
    | null /* How often Collector gathers data and sends to API. */;
  collector_id: number /* Unique identifier for a Collector. */;
  description?: string | null /* Description of Collector. */;
  dhcp?: boolean | null /* Primary physical network uses DHCP? */;
  dhcp_2?: boolean | null /* Secondary physical network uses DHCP? */;
  dns?: string | null /* Primary physical network DNS server(s). */;
  dns_2?: string | null /* Secondary physical network DNS server(s). */;
  gateway?: string | null /* Primary physical network interface Gateway. */;
  gateway_2?: string | null /* Secondary physical network interface Gateway. */;
  history_synced_at?: Moment | null /* Timestamp of last successful sync with API. */;
  last_polled_at?: Moment | null /* Timestamp of last successful bacer poll will API. */;
  last_modified_at?: Moment | null /* Timestamp of Collector record was last changed. */;
  registered_at: Moment /* Timestamp of Collector creation/registration. */;
  hostname?: string | null /* Hostname of Collector. */;
  interface_name?: string | null /* Primary physical network interface. */;
  interface_name_2?: string | null /* Secondary physical network interface. */;
  ip_address?:
    | string
    | null /* Primary physical network interface IP address. */;
  ip_address_2?:
    | string
    | null /* Secondary physical network interface IP address. */;
  is_active: boolean /* Is Collector active? */;
  mac_address?:
    | string
    | null /* Primary physical network interface MAC address. */;
  mac_address_2?:
    | string
    | null /* Secondary physical network interface MAC address. */;
  site: Site /* Site object for current Collector. */;
  subnet_mask?:
    | string
    | null /* Primary physical network interface Subnet mask. */;
  subnet_mask_2?:
    | string
    | null /* Secondary physical network interface Subnet mask. */;
  sync_interval?:
    | number
    | null /* How often Collector syncs with API (in seconds). */;
  collector_type: CollectorType;
  configuration: BacerConfig;
  // TODO cleanup: remove once BE converts configuration to :JSON
  _configuration: BacerConfig;
  adaptive_control_history?: Maybe<CollectorAdaptiveControlHistory>;
  collector_notes?: Maybe<CollectorNote[]>;
}

export interface CollectorAdaptiveControlHistory {
  collector_id: Scalars['Int'];
  fav_id: Scalars['Long'];
  data: Scalars['Float'];
  ts: Moment;
  favourite?: Maybe<Favourite>;
  error_msg?: Maybe<Scalars['String']>;
  info_msg?: Maybe<Scalars['String']>;
}

export interface DemandRate {
  start_ts: DateTime;
  rate: number;
}

export interface OccupiedMeterage {
  occupied_start_ts: DateTime;
  square_meterage: number;
}


export interface SiteSnoozeMonitoring {
  site_snooze_monitoring_id?: number;
  site_id: number;
  suspend_until: Moment;
  created_at?: Moment;
  suspended_by?: string;
  suspended_by_user?: User;
}

export type SiteReferenceId = number;

/* An external system's reference for a Site. */
export interface SiteExternalReference {
  site_reference_id: SiteReferenceId /* Unique identifier of the Site External Reference. */;
  label: string /* Label of the External Reference. Unique per Site. */;
  external_reference: string /* The reference value in the external system. */;
}


/* A Site. */
export interface Site {
  address_line_1: string /* Physical address of Site. */;
  address_line_2?: string | null /* Additional address details of Site. */;
  base_temperature?: number | null /* Site baseline temperature. */;
  city: string /* City site is located in. */;
  client_id?: number | null /* Client ID for current Site. */;
  consulting_start_ts?: DateTime | null /* The date and time site consultation started. */;
  country: string /* Country site is located in. */;
  demand_peak_billing_model?:
    | string
    | null /* Type of peak demand charging model used by electricity supplier */;
  demand_peak_schedule?: JSON | null /* Rate at which demand is charged at a period in time */;
  electricity_charge_rate?:
    | number
    | null /* Electricity charge rate per kWh. */;
  water_charge_rate?: number | null;  /* Water charge rate per kL. */
  gas_charge_rate?: number | null;  /* Gas charge rate per Mj. */
  email_address?:
    | string
    | null /* Email address data will be sent to for vACEr processing. */;
  first_report_issued_ts?: DateTime | null /* The date and time first client report was issued. */;
  first_resolved_issue_ts?: DateTime | null /* The date and time first issue was resolved. */;
  geo_coordinates?:
    | string
    | null /* Latitude,Longitude coordinates for location of Site. */;
  norm_intercept?: number | null /* Site normalization intercept. */;
  norm_occupancy_co?:
    | number
    | null /* Site normalization occupancy coefficient. */;
  norm_slope?: number | null /* Site normalization slope. */;
  postcode: string /* Post code of Site. */;
  potential_annual_savings?:
    | number
    | null /* Stores realised and available saving on site for Electricity */;
  potential_annual_savings_water?: number | null;  /* Stores realised and available saving on site for Water */
  potential_annual_savings_gas?: number | null;  /* Stores realised and available saving on site for Gas */
  provider_id?: MeterProviderId | null /* Unique identifier for a Meter Provider. */;
  reporting_start_ts?: DateTime | null /* The earliest date and time reports are generated from. */;
  site_id: number /* Unique identifier for a Site. */;
  site_name: string /* Name of Site. */;
  state: string /* State site is located in. */;
  thermalcomfort_schedule?: Maybe<ThermalComfortSchedule> /* Schedule for Thermal Comfort related views. */;
  timezone: string /* Timezone for location of Site. */;
  working_hours?: WorkingHours | null /* Working Hours for Site. */;
  is_active: boolean;
  occupied_meterages?: OccupiedMeterage[] | null;
  demand_rates?: DemandRate[] | null;
  nmi_streams?: MeterStream[] | null;
  nmi_numbers?: Meter[] | null;
  clients?: number[] | null;
  client_mappings?: SiteToUserIdByUserEntityIdMapping | null;
  contractor_mappings?: SiteToUserIdByUserEntityIdMapping | null;
  customer_mappings?: SiteToUserIdByUserEntityIdMapping | null;
  thermal_comfort_humidity_available?: boolean | null;
  thermal_comfort_min_temp?: number;
  thermal_comfort_max_temp?: number;
  thermal_comfort_margin?: number;
  ideal_relative_humidity_min?: number;
  ideal_relative_humidity_max?: number;
  ideal_relative_humidity_margin?: number;
  levels?: Maybe<Array<Maybe<Level>>>;
  zones?: Maybe<Array<Maybe<Zone>>>;
  cop?: number;
  customer_id?: number;
  monetary_currency: Currency;
  contractor_target_closure_rate?: number;
  building_type: Maybe<Scalars['BuildingTypeEnum']>;
  nabers_bounds_schedules?: Maybe<Array<NabersBoundsSchedule>>;
  external_references?: Maybe<Array<SiteExternalReference>>;
  license_tier: Scalars['LicenseTierEnum'];
  photo_url?: Maybe<Scalars['String']>;
  building_size?: Maybe<Scalars['Double']>;
  equipment_health_target_pass_rate?: Maybe<Scalars['Double']>;
}

/** Thermal Comfort Schedule. */
export interface ThermalComfortSchedule {
  __typename?: 'ThermalComfortSchedule',
 /** Hour Schedule ends each day. */
 day_end: Scalars['String'],
 /** Hour Schedule starts each day. */
 day_start: Scalars['String'],
 /** Exclude weekends from Schedule. */
 exclude_weekends: Scalars['Boolean'],
}

/* A Contractor. */
export interface Contractor {
  contractor_id: number /* Unique identifier for a Contractor. */;
  name: string /* Name of Contractor. */;
}

export interface SiteContractorMapping {
  user_id: string /* Unique identifier for a User. */;
  contractor_id: number /* Unique identifier for a Contractor. */;
}

export interface SiteToUserIdByUserEntityIdMapping {
  [entity_id: number]: Scalars['String'][]
}


/* A BACNet Device. */
export interface Device {
  bacnet_device_id?: number /* BACNet device ID. */;
  bacnet_device_name?: string /* BACNet device name. */;
  canonical_favourite_ids?:
    | Long[]
    | null /* List of Favourites belonging to this Device. */;
  collector_id?: number,
  collector?: Collector /* Collector object for current Device. */;
  comment?: string | null /* Comments. */;
  device_id: Long /* Unique identifier for a BACNet device. */;
  device_label?: string | null /* Device label. */;
  discovered_at?: DateTime /* Timestamp Device was first discovered. */;
  is_active?: boolean /* Is Device active? */;
  last_modified_at?: DateTime | Moment;
  lastseen_at?: DateTime | Moment/* Timestamp Device was last seen. */;
  model?: string | null /* Device Model. */;
  updated_at?: DateTime /* Timestamp Device was last updated. */;
  vendor?: string | null /* Device Vendor. */;
  primary_equipment?: Equipment[];
  device_objects?: DeviceObject[];
}

export interface DeviceObject {
  device_object_id?: Long;
  device_id?: number;
  object_name?: string;
  object_identifier?: string;
  description?: string;
  present_value?: number;
  units?: string;
  device?: Device;
  favourite?: Favourite;
  last_modified_at?: Moment;
  predictions?: DeviceObjectPrediction;
}

export interface MetadataPrediction {
  metadata_id: number;
  score: Long;
}

export interface DeviceObjectPrediction {
  metadata_predictions: MetadataPrediction[];
}

export type EquipmentId = Long;

export type EquipmentReferenceId = number;

/* An external system's reference for a piece of Equipment. */
export interface EquipmentExternalReference {
  equipment_reference_id: EquipmentReferenceId /* Unique identifier of the Equipment External Reference. */;
  label: string /* Label of the External Reference. Unique per piece of Equipment. */;
  external_reference: string /* The reference value in the external system. */;
}

export interface EquipmentProperty {
  property_name: string;
  value: string | number | boolean | null;
}

/* A piece of Equipment. */
export interface Equipment {
  canonical_favourite_ids?:
    | Long[]
    | null /* List of Favourites belonging to this Equipment. */;
  capacity?: number | null /* Capacity of Equipment. */;
  capacity_unit?: string | null /* Unit of measure for Equipment capacity. */;
  collector?: Collector /* Collector object for current Equipment. */;
  collector_id?: number /* Unique identifier for a Collector. */;
  comment?: string | null /* Comments. */;
  energyconsumption?: number | null /* Energy Consumption of Equipment. */;
  energyconsumption_unit?:
    | string
    | null /* Unit of measure for Equipment energy consumption. */;
  equipment_id?: EquipmentId /* Unique identifier for a piece of Equipment. */;
  favourite_ids?:
    | Long[]
    | null /* List of Favourites belonging to this Equipment, including any Favourites from related Shared Equipment. */;
  is_active?: boolean /* Is Equipment active? */;
  metadata_type?: MetadataType | null /* Metadata Type object for current Equipment. */;
  metadata_type_id?: number | null /* Metadata Type of Equipment. */;
  model?: string | null /* Model of Equipment. */;
  name?: string /* Name of Equipment. */;
  related_equipment?: Long[] | null /* List of related equipment ids */;
  role?: string | null /* Role of Equipment. */;
  shared?: boolean | null /* Is Equipment shared? */;
  vendor?: string | null /* Vendor of Equipment. */;
  virtual?: boolean /* Is Equipment physical or virtual? */;
  favourites?: Favourite[];
  primary_device_id?: number;
  primary_device?: Device;
  file_ids?: number[];
  files?: VirtualFile[]; /* Enriched by code, not returned by graphql query */
  zone_id?: number;
  zone?: Maybe<Zone>;
  target_running_load?: number;
  parent_equipment_ids?: number[];
  parent_equipment?: Equipment[];
  ancestor_equipment_ids?: number[];
  descendant_equipment_ids?: number[];
  maintainer_name?: string;
  maintainer_reference?: string;
  operation_duration_per_year?: string | null;
  equipment_properties?: EquipmentProperty[] | null /* Generic name/value properties for this Equipment. */;
  external_references?: EquipmentExternalReference[] | null /* External systems' references for this Equipment. */;
}

export type MetadataTypeId = number;

/* Metadata Type. */
export interface MetadataType {
  commissionable?: boolean;
  system?: boolean;
  type: string /* Name of Metadata Type. */;
  type_code?: string /* Short code for Metadata Type. */;
  type_id?: MetadataTypeId /* Unique identifier for a type of Metadata. */;
  customer_id?: number;
  shared?: boolean;
}

export type FavouriteId = Long;

/* A Favourite. */
export interface Favourite {
  canonical_equipment_id?: Long /* Canonical identifier for a piece of Equipment. */;
  comment?: string | null /* Comments. */;
  equipment?: Equipment /* Equipment object for current Favourite. */;
  equipment_id?: Long /* Unique identifier for a piece of Equipment. */;
  equipment_ids?:
    | Long[]
    | null /* Equipment identifiers for all related equipment when Favourite belongs to Shared equipment. */;
  fav_id?: FavouriteId /* Unique identifier for a Favourite. */;
  identifier?: string /* Identifier for Favourite. */;
  device_object_id?: Long;
  device_object?: DeviceObject;
  is_active?: boolean | null /* Is Favourite active? */;
  metadata?: Metadata /* Metadata object for current Favourite. */;
  metadata_id?: number /* Unique identifier for a piece of Metadata. */;
  collector?: Collector;
  zone_id?: number;
  history?: History[] | null;
  zone?: Maybe<Zone>;
  last_modified_at?: string | Moment;
}

export type MetadataId = number;
export type MetadataUnitId = number;

/* Metadata. */
export interface Metadata {
  commissionable?: boolean;
  system?: boolean;
  code?: string /* Short code for Metadata. */;
  metadata_id?: MetadataId /* Unique identifier for a piece of Metadata. */;
  name?: string /* Name of Metadata. */;
  type?: MetadataType | null /* Metadata Type object for current Metadata. */;
  type_id: number /* Unique identifier for a type of Metadata. */;
  unit?: MetadataUnit | null /* Metadata Unit object for current Metadata. */;
  unit_id?: number /* Unique identifier for Unit of Metadata. */;
  customer_id?: number;
  shared?: boolean;
}
/* Metadata Unit. */
export interface MetadataUnit {
  unit: string /* Value for Metadata Unit. */;
  unit_id?: MetadataUnitId /* Unique identifier for unit of Metadata. */;
  shared?: boolean;
  customer_id?: number;
  system?: boolean;
}
/* Favourite History. */
export interface History {
  fav_id: Long /* Unique identifier for a Favourite. */;
  data: number /* Value for the Favourite. */;
  ts: Moment /* Timestamp when the data occurred. */;
}
/* History Count. */
export interface HistoryCount {
  count?: number | null /* Count of History records. */;
}


export type GreenButtonConnectClientId = string;


export interface GreenButtonConnectProperties {
  authorization_url: string;
  authorization_client_id: string;
  client_id: GreenButtonConnectClientId;
  token_url: string;
  token_url_param_type: string;
  resource_base_url: string;
  ingestion_mode: string;
  ip_whitelist: string[];
}


interface MeterProviderExternalIntegrations {
  green_button_connect: GreenButtonConnectProperties;
}



export type MeterProviderId = Scalars['Int'];

/** A Meter Provider. */
export interface MeterProvider {
  __typename?: 'MeterProvider',
  /** Unique identifier for a Meter Provider. */
  provider_id: MeterProviderId,
  /** Name of Meter Provider. */
  provider_name: Scalars['String'],
  /** Interval data is collected for Meter Provider. */
  collection_interval?: Maybe<Scalars['Period']>,
  /** Email address meter data will be sent to for vACEr processing. */
  collector_email_address: Scalars['String'],
  /** Contact email address for Meter Provider. */
  contact_email_address: Scalars['String'],
  /** ID of Customer Meter Provider belongs to. */
  customer_id: Scalars['Int'],
  /** Data Interval for Meter Provider. */
  data_interval?: Maybe<Scalars['Period']>,
  /** Interval Meter Provider uses for Demand Peak calculations. */
  demand_peak_calculation_interval?: Maybe<Scalars['Period']>,
  /** Last modified at. */
  last_modified_at?: Scalars['DateTime'],
  /** Timezone Meter Provider provides data in. */
  timezone?: Maybe<Scalars['String']>,
  validate_nmi_numbers?: Maybe<Scalars['Boolean']>,
  forward_email?: boolean,
  forward_email_address?: string;
  external_integrations?: Maybe<MeterProviderExternalIntegrations>;
}

export interface CollectorsQueryRootArgs {
  collector_id?: number | null /* Search for a specific Collector by id. */;
  collector_ids?: number[] | null /* Search for a range of Collectors by id. */;
  hostname?: string | null /* Search for Collectors by hostname. */;
  site_id?: number | null /* Search for Collectors by Site id. */;
  site_ids?: number[] | null /* Search for Collectors by range of Site ids. */;
  virtual?: string | null /* Search for Collectors by virtual status. */;
}
export interface ContractorsQueryRootArgs {
  contractor_id?: number | null /* Search for a specific Contractor by id. */;
  contractor_ids?:
    | number[]
    | null /* Search for a range of Contractors by id. */;
  name?: string | null /* Search for Contractors by name. */;
}
export interface DevicesQueryRootArgs {
  bacnet_device_id?:
    | number
    | null /* Search for Devices by BACNet device id. */;
  bacnet_device_name?:
    | string
    | null /* Search for Devices by BACNet device name. */;
  collector_id?: number | null /* Search for Devices by Collector id. */;
  collector_ids?:
    | number[]
    | null /* Search for Devices by range of Collector ids. */;
  device_id?: Long | null /* Search for a specific Device by id. */;
  device_ids?: Long[] | null /* Search for a range of Devices by id. */;
  device_label?: string | null /* Search for Devices by device label. */;
  model?: string | null /* Search for Devices by model. */;
  vendor?: string | null /* Search for Devices by vendor. */;
}
export interface EquipmentQueryRootArgs {
  collector_id?: number | null /* Search for Equipment by Collector id. */;
  collector_ids?:
    | number[]
    | null /* Search for Equipment by range of Collector ids. */;
  equipment_id?: Long | null /* Search for a specific piece of Equipment by id. */;
  equipment_ids?: Long[] | null /* Search for a range of Equipment by id. */;
  metadata_type_id?:
    | number
    | null /* Search for Equipment by Metadata Type id. */;
  metadata_type_ids?:
    | number[]
    | null /* Search for Equipment by range of Metadata Type ids. */;
  model?: string | null /* Search for Equipment by model. */;
  name?:
    | string
    | null /* Search for Equipment by name. Case-insensitive and supports SQL LIKE syntax for matching. */;
  provider_id?: MeterProviderId | null /* Search for Equipment by Meter Provider id. */;
  provider_ids?:
    | MeterProviderId[]
    | null /* Search for Equipment by range of Meter Provider ids. */;
  shared?: string | null /* Search for Equipment by shared status. */;
  site_id?: number | null /* Search for Equipment by Site id. */;
  site_ids?: number[] | null /* Search for Equipment by range of Site ids. */;
  vendor?: string | null /* Search for Equipment by vendor. */;
  virtual?: string | null /* Search for Equipment by virtual status. */;
}
export interface FavouritesQueryRootArgs {
  collector_id?: number | null /* Search for Favourites by Collector id. */;
  collector_ids?:
    | number[]
    | null /* Search for Favourites by range of Collector ids. */;
  equipment_id?: Long | null /* Search for Favourites by Equipment id. */;
  equipment_ids?:
    | Long[]
    | null /* Search for Favourites by range of Equipment ids. */;
  fav_id?: Long | null /* Search for a specific Favourite by id. */;
  fav_ids?: Long[] | null /* Search for a range of Favourites by id. */;
  identifier?:
    | string
    | null /* Search for Favourites by identifier. Case sensitive and exact matches only. */;
  identifier_filter?:
    | string
    | null /* Search for Favourites by identifier. Case-insensitive and supports SQL LIKE syntax for matching. */;
  metadata_code?: string | null /* Search for Favourites by Metadata Code. */;
  metadata_codes?:
    | string[]
    | null /* Search for Favourites by range of Metadata Codes. */;
  metadata_id?: number | null /* Search for Favourites by Metadata id. */;
  metadata_ids?:
    | number[]
    | null /* Search for Favourites by range of Metadata ids. */;
  metadata_name?:
    | string
    | null /* Search for Favourites by Metadata name. Case-insensitive and supports SQL LIKE syntax for matching. */;
  site_id?: number | null /* Search for Favourites by Site id. */;
  site_ids?: number[] | null /* Search for Favourites by range of Site ids. */;
}
export interface HistoryQueryRootArgs {
  end: DateTime /* Timestamp of end of History records. */;
  fav_id?: Long | null /* Search for a History by a specific Favourite id. */;
  fav_ids?:
    | Long[]
    | null /* Search for History given a range of Favourite ids. */;
  start: DateTime /* Timestamp of start of History records. */;
}
export interface HistoryCountQueryRootArgs {
  end: DateTime /* Timestamp of end of History records. */;
  fav_id?: Long | null /* Get History Count for a specific Favourite. */;
  fav_ids?: Long[] | null /* Get History Count for a range of Favourites. */;
  start: DateTime /* Timestamp of start of History records. */;
}
export interface MetadataQueryRootArgs {
  metadata_id?:
    | number
    | null /* Search for a specific piece of Metadata by id. */;
  metadata_ids?: number[] | null /* Search for a range of Metadata by id. */;
  type_id?: number | null /* Search for Metadata of specific type by id. */;
  type_ids?:
    | number[]
    | null /* Search for a range of Metadata of specific type by id. */;
}
export interface MetadataTypesQueryRootArgs {
  type_id?: number | null /* Search for a specific Metadata Type by id. */;
  type_ids?: number[] | null /* Search for a range of Metadata Types by id. */;
}
export interface MetadataUnitsQueryRootArgs {
  unit_id?: number | null /* Search for a specific Metadata Unit by id. */;
  unit_ids?: number[] | null /* Search for a range of Metadata Units by id. */;
}
export interface MeterProvidersQueryRootArgs {
  collector_email_address?:
    | string
    | null /* Search for Meter Providers by email address. */;
  provider_id?: MeterProviderId | null /* Search for a specific Meter Provider by id. */;
  provider_ids?:
    | MeterProviderId[]
    | null /* Search for a range of Meter Providers by id. */;
}
export interface SitesQueryRootArgs {
  city?: string | null /* Search for Sites by city. */;
  client_id?: number | null /* Search for Sites by Client id. */;
  client_ids?: number[] | null /* Search for Sites by range of Client ids. */;
  country?: string | null /* Search for Sites by country. */;
  email_address?: string | null /* Search for Sites by email address. */;
  is_active?: string | null /* Is site active? */;
  nmi_numbers?: string[] | null /* Search for Sites by NMI Numbers. */;
  postcode?: string | null /* Search for Sites by postcode. */;
  provider_id?: MeterProviderId | null /* Search for Sites by Meter Provider id. */;
  provider_ids?:
    | MeterProviderId[]
    | null /* Search for Sites by range of Meter Provider ids. */;
  site_id?: number | null /* Search for a specific Site by id. */;
  site_ids?: number[] | null /* Search for a range of Sites by id. */;
  state?: string | null /* Search for Sites by state. */;
  timezone?: string | null /* Search for Sites by timezone. */;
}
export interface ThermalcomfortHistoryQueryRootArgs {
  day_end: string /* End of working day. */;
  day_start: string /* Start of working day. */;
  end: DateTime /* Timestamp of end of Thermal Comfort History records. */;
  exclude_weekends?:
    | boolean
    | null /* Exclude data from Weekends (defaults to True). */;
  fav_id?: Long | null /* Search for Thermal Comfort History by a specific Favourite id. */;
  fav_ids?:
    | Long[]
    | null /* Search for Thermal Comfort History given a range of Favourite ids. */;
  in_temp_range?:
    | boolean
    | null /* Return History within supplied Thermal Comfort Temperature Range when true, outside range when false. */;
  max_temp?: number | null /* Maximum temperature. */;
  min_temp?: number | null /* Minimum temperature. */;
  start: DateTime /* Timestamp of start of Thermal Comfort History records. */;
  timezone?:
    | string
    | null /* Timezone to use for start/end of day and weekend filters. */;
}

export interface VirtualFile {
  file_id?: number;
  filename_pattern?: string;
  format_id?: number;
  format?: VirtualFileFormat;
  site_ids?: number[];
  timezone?: string;
  description?: string;
  collection_interval?: string;
  data_interval?: string;
  decimal_separator?: string;
  grouping_separator?: string;
}


/* Virtual File Formats. */
export interface VirtualFileFormat {
  description?: string | null /* Description of File Format. */;
  file_format: string /* File Format for a Virtual File. */;
  format_id: number /* Unique identifier for a File Format. */;
}

export interface WorkingHours {
  fridayEnabled: boolean;
  fridayEnd: string;
  fridayStart: string;
  mondayEnabled: boolean;
  mondayEnd: string;
  mondayStart: string;
  saturdayEnabled: boolean;
  saturdayEnd: string;
  saturdayStart: string;
  sundayEnabled: boolean;
  sundayEnd: string;
  sundayStart: string;
  thursdayEnabled: boolean;
  thursdayEnd: string;
  thursdayStart: string;
  tuesdayEnabled: boolean;
  tuesdayEnd: string;
  tuesdayStart: string;
  wednesdayEnabled: boolean;
  wednesdayEnd: string;
  wednesdayStart: string;
}

export type LevelId = Scalars['Long'];

/** Levels in a site */
export interface Level {
  __typename?: 'Level',
 /** The maximum acceptable relative humidity percentage. */
 ideal_relative_humidity_max?: Maybe<Scalars['Float']>,
 /** The minimum acceptable relative humidity percentage. */
 ideal_relative_humidity_min?: Maybe<Scalars['Float']>,
 /** relative humidity margin */
 ideal_relative_humidity_margin?: Maybe<Scalars['Float']>,
 /** Unique identifier of level in a site */
 level_id: LevelId,
 /** Name for levels in a site */
 level_name: Scalars['String'],
 /** Unique identifier of a site */
 site_id: Scalars['Int'],
 /** Whether the level in a site is a SYSTEM level */
 system?: Maybe<Scalars['Boolean']>,
 /** List of tenant ids in the level. */
 tenant_ids?: Maybe<Array<Maybe<Scalars['Long']>>>,
 /** The maximum acceptable thermal comfort temperature. */
 thermal_comfort_max_temp?: Maybe<Scalars['Float']>,
 /** The minimum acceptable thermal comfort temperature. */
 thermal_comfort_min_temp?: Maybe<Scalars['Float']>,
 /** thermal comfort margin */
 thermal_comfort_margin?: Maybe<Scalars['Float']>,
 /** Excluded from thermal comfort related views. */
 thermalcomfort_excluded?: Maybe<Scalars['Boolean']>,
 /** Schedule for thermal comfort related views. */
 thermalcomfort_schedule?: Maybe<ThermalComfortSchedule>,
 /** List of zones in the level. */
 zones?: Maybe<Array<Maybe<Zone>>>,
}


export type ZoneId = Scalars['Long'];
/** Zones in a site */
export interface Zone {
   __typename?: 'Zone',
  /** The maximum acceptable relative humidity percentage. */
  ideal_relative_humidity_max?: Maybe<Scalars['Float']>,
  /** The minimum acceptable relative humidity percentage. */
  ideal_relative_humidity_min?: Maybe<Scalars['Float']>,
  /** relative humidity margin */
  ideal_relative_humidity_margin?: Maybe<Scalars['Float']>,
  /** Level information */
  level?: Level,
  /** Unique identifier of level in a site */
  level_id: LevelId,
  /** Unique identifier of a site */
  site_id: Scalars['Int'],
  /** Whether the zone in a site is a SYSTEM zone name */
  system?: Maybe<Scalars['Boolean']>,
  /** List of tenant ids in the zone. */
  tenant_ids?: Maybe<Array<Maybe<Scalars['Long']>>>,
  /** The maximum acceptable thermal comfort temperature. */
  thermal_comfort_max_temp?: Maybe<Scalars['Float']>,
  /** The minimum acceptable thermal comfort temperature. */
  thermal_comfort_min_temp?: Maybe<Scalars['Float']>,
  /** thermal comfort margin */
  thermal_comfort_margin?: Maybe<Scalars['Float']>,
  /** Excluded from thermal comfort related views. */
  thermalcomfort_excluded?: Maybe<Scalars['Boolean']>,
  /** Schedule for thermal comfort related views. */
  thermalcomfort_schedule?: Maybe<ThermalComfortSchedule>,
  /** Unique identifier of zone in a site */
  zone_id: ZoneId,
  /** Zone Name information */
  zone_name?: ZoneName,
  /** Unique identifier of zone name in a site */
  zone_name_id: ZoneNameId,
}


export type ZoneNameId = Scalars['Long'];
/** Zone names in a site */
export interface ZoneName {
   __typename?: 'ZoneName',
  /** Unique identifier of a site */
  site_id: Scalars['Int'],
  /** Whether the zone name in a site is a SYSTEM zone name */
  system?: Maybe<Scalars['Boolean']>,
  /** Name for zone in a site */
  zone_name: Scalars['String'],
  /** Unique identifier of zone name in a site */
  zone_name_id: ZoneNameId,
}

/** Meter Number. */
export interface Meter {
  __typename?: 'Meter',
 /** Interval data is collected for NMI Number . */
  collection_interval?: Maybe<Scalars['Period']>,
 /** ID of Customer NMI Number belongs to. */
  customer_id?: Scalars['Int'],
 /** Data Interval for NMI Number. */
  data_interval?: Maybe<Scalars['Period']>,
 /** Interval NMI Number uses for Demand Peak calculations. */
  demand_peak_calculation_interval?: Maybe<Scalars['Period']>,
 /** Does this Meter have any History? */
  history_available?: Maybe<Scalars['Boolean']>
 /** Last modified at. */
  last_modified_at?: Scalars['DateTime'],
 /** Meter type of NMI Number. */
  meter_type: Maybe<Scalars['MeterTypeEnum']>,
 /** Unique identifier for NMI Number. */
  nmi_id: Scalars['Int'],
 /** NMI Number. */
  nmi_number: Scalars['String'],

  /** Display Name */
  display_name?: Scalars['String'];

  /** NMI Streams for NMI Number. */
  nmi_streams?: Maybe<Array<Maybe<MeterStream>>>,
 /** Parent NMI Id of NMI Number. */
  parent_nmi_id?: Maybe<Scalars['Int']>,
 /** Parent Stream of NMI Number. */
  parent_stream?: Maybe<MeterStream>,
 /** Parent Stream Id of NMI Number. */
  parent_stream_id?: Maybe<Scalars['String']>,
 /** Provider NMI Number belongs to. */
  provider?: MeterProvider,
 /** ID of Provider NMI Number belongs to. */
 provider_id: MeterProviderId,
 /** Site NMI Number is assigned to. */
  site?: Maybe<Site>,
 /** ID of Site NMI Number is assigned to. */
  site_id?: Maybe<Scalars['Int']>,
 /** Timezone NMI Number provides data in. */
  timezone?: Maybe<Scalars['String']>,
 /** Utility type of NMI Number. */
  utility_type: Maybe<Scalars['MeterUtilityTypeEnum']>,
 /** Peak Demand Max Target. */
  peak_demand_max_target?: Maybe<Scalars['Float']>,
 /** Virtual Meter calc type. */
  virtual_meter_calculation_type?: Maybe<Scalars['VirtualMeterCalculationTypeEnum']>;
 /** Virtual Meter calc entities. */
  virtual_meter_calculation_entities?: Maybe<Array<Scalars['Int']>>;

  displayName?: Scalars['String'];
}


/** Meter Stream. */
export interface MeterStream extends MeterStreamId {
  __typename?: 'MeterStream',
 /** Base Temperature. */
  base_temperature?: Maybe<Scalars['Float']>,
 /** Base Temperature for Heating. */
  base_temperature_heating?: Maybe<Scalars['Float']>,

  /** Display Name */
  display_name?: Maybe<Scalars['String']>,

  /** Description. */
  description?: Maybe<Scalars['String']>,
 /** Equipment for Stream. */
  equipment: Equipment,
 /** ID of Equipment for Stream. */
  equipment_id: Scalars['Long'],
 /** Last modified at. */
  last_modified_at: Scalars['DateTime'],
 /** NMI Number Stream belongs to. */
  nmi: Meter,
  nmi_number: Scalars['String'],
 /** Normalised Intercept. */
 norm_intercept?: Maybe<Scalars['Float']>,
 /** Normalised Occupancy Coefficient. */
  norm_occupancy_co?: Maybe<Scalars['Float']>,
 /** Normalised Slope. */
  norm_slope?: Maybe<Scalars['Float']>,
 /** Normalised Slope for Heating. */
  norm_slope_heating?: Maybe<Scalars['Float']>,
 /** Is Stream reportable? */
  reportable: Scalars['Boolean'],
 /** NMI Stream History. */
  stream_history?: Maybe<Array<Maybe<MeterStreamHistory>>>,
 /** Sub meters off current stream. */
  sub_meters?: Maybe<Array<Maybe<Meter>>>,
  meter_stream_source_favourite_config?: Maybe<MeterStreamSourceFavouriteConfig>
 /** Does this Stream have any History? */
  history_available?: Maybe<Scalars['Boolean']>;
  fill_gaps?: Scalars['Boolean'];

  displayName: Scalars['String'];
}

/** Meter Stream History. */
export interface MeterStreamHistory {
  __typename?: 'MeterStreamHistory',
 /** Data Type for NMI Stream. */
 data_type: Scalars['StreamDataTypeEnum'],
 /** Interval Date for NMI Stream data. */
 interval_date: Scalars['LocalDate'],
 /** Last Updated Timestamp for NMI Stream data for associated Interval Date. */
 last_updated_at: Scalars['DateTime'],
 /** NMI ID for NMI Stream. */
 nmi_id: Scalars['Int'],
 /** Stream ID for NMI Stream. */
 stream_id: Scalars['String'],
}

export interface MeterStreamSourceFavouriteConfig {
  __typename?: 'MeterStreamSourceFavouriteConfig';
  stream_id: Scalars['String'];
  nmi_id: Scalars['Int'];
  active_max_value: Scalars['Float'];
  reactive_max_value: Scalars['Float'];
  active_multiplier: Scalars['Float'];
  reactive_multiplier: Scalars['Float'];
  active_import_fav_id?: Scalars['Long'];
  active_export_fav_id?: Scalars['Long'];
  reactive_import_fav_id?: Scalars['Long'];
  reactive_export_fav_id?: Scalars['Long'];
  active_interval_usage_limit?: Scalars['Float'],
  reactive_interval_usage_limit?: Scalars['Float'],
  stream?: Maybe<MeterStream>;
}

export interface NabersBoundsSchedule {
  nabers_bounds_schedule_id: Scalars['Int'];
  start_date: Scalars['DateTime'];
  site_id: Scalars['Int'];
  bound_0: Scalars['Float'];
  bound_1: Scalars['Float'];
  bound_2: Scalars['Float'];
  bound_3: Scalars['Float'];
  bound_4: Scalars['Float'];
  bound_5: Scalars['Float'];
  bound_6: Scalars['Float'];
  bound_7: Scalars['Float'];
  bound_8: Scalars['Float'];
  bound_9: Scalars['Float'];
  bound_10: Scalars['Float'];
  bound_11: Scalars['Float'];
  bound_12: Scalars['Float'];
}

export interface MeterStreamId {
  /** Identifier of the meter this stream belongs to. */
  nmi_id: Scalars['Int'];
  /** Stream Identifier. */
  stream_id: Scalars['String'];
}

type MomentTuple = [Moment, Moment];
export interface DateTimeRangeTuple extends MomentTuple {}
export interface LocalDateTimeRangeTuple extends MomentTuple {}
export type Interval = string;
export type LocalInterval = string;
